import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from "./pages/DetailPage.tsx";

export const CodeRepositoriesLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action='ListPipelines' redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':name'
                element={
                    <RequirePermission action='ListPipelines' redirectTo='/code-repositories'>
                        <DetailPage/>
                    </RequirePermission>
                }

            >
            </Route>


        </Routes>
    );
};
